import { render, staticRenderFns } from "./FinanceAdd.vue?vue&type=template&id=e3989bf6&"
import script from "./FinanceAdd.vue?vue&type=script&lang=ts&"
export * from "./FinanceAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports